export enum KitRunStatus {
    Included = 1,
    ManuallyExcluded = 2,
    QTestExcluded = 3,
    RerunExcluded = 4,
}

export const kitRunStatuses = [
    { id: 0, name: "" },
    { id: 1, name: "Included" },
    { id: 2, name: "Excluded (Manually)" },
    { id: 3, name: "Excluded (Q Test)" },
    { id: 4, name: "Excluded (Reran)" },
]